import { FC } from 'react';
import { Space } from 'antd';
import { FormOutlined, MinusCircleOutlined, VideoCameraOutlined } from '@ant-design/icons';
import { Tag } from '@maxtropy/components';
import { FunCallback, levelDisplay, NodeType } from '../../utils';
import styles from './index.module.scss';

interface TreeNodeProps {
  nodeData: any;
  showIcon: boolean;
  searchValue: string;
  edit?: FunCallback;
  editVideo?: FunCallback;
  remove?: FunCallback;
  hasEditPermission: boolean;
  hasRemovePermission: boolean;
}

const TreeNode: FC<TreeNodeProps> = ({
  nodeData,
  edit,
  editVideo,
  remove,
  searchValue = '',
  showIcon,
  hasEditPermission,
  hasRemovePermission,
}) => {
  const { name, level, type } = nodeData;
  const strTitle = name as string;
  const index = strTitle.indexOf(searchValue);
  const beforeStr = strTitle.substring(0, index);
  const afterStr = strTitle.slice(index + searchValue.length);
  let title =
    index > -1 ? (
      <span style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
        {beforeStr}
        <span style={{ color: 'red' }}>{searchValue}</span>
        {afterStr}
      </span>
    ) : (
      <span>{strTitle}</span>
    );
  return (
    <div className={styles.title}>
      {title}
      {type === NodeType.ROOM ? (
        <Tag border="solid" color="default">
          {levelDisplay[level]}
        </Tag>
      ) : null}

      {showIcon && (
        <div className={styles.iconBox}>
          {hasEditPermission && (
            <FormOutlined
              onClick={(e: any) => {
                e.stopPropagation();
                edit?.(nodeData);
              }}
              style={{ color: 'var(--mx-primary-color)' }}
            />
          )}
          {hasRemovePermission && (
            <MinusCircleOutlined
              onClick={(e: any) => {
                e.stopPropagation();
                remove?.(nodeData);
              }}
              style={{ color: 'var(--mx-primary-color)' }}
            />
          )}
          {type === NodeType.ROOM && (
            <VideoCameraOutlined
              onClick={(e: any) => {
                e.stopPropagation();
                editVideo?.(nodeData);
              }}
              style={{ color: 'var(--mx-primary-color)' }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default TreeNode;
